import { Link } from "react-router-dom";
import { MapPin, Phone } from "lucide-react";
import { Logo } from "@/components/Logo";
import { HOTEL } from "@/constants/hotelData";
import { scrollToSection } from "@/components/Nav";

export default function Footer() {
  return (
    <footer className="border-t border-gold/15 bg-[#0f241b]">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-5 py-16 sm:px-8 md:grid-cols-3">
        <div>
          <Logo />
          <p className="mt-5 max-w-xs text-sm font-light leading-relaxed text-stone-400">
            {HOTEL.tagline}. Twenty rooms, one promise — a royal rest in East
            Champaran.
          </p>
        </div>
        <div>
          <h4 className="text-[10px] font-medium uppercase tracking-[0.28em] text-gold">Explore</h4>
          <div className="mt-5 flex flex-col gap-3">
            {[
              { label: "Rooms & Suites", href: "#rooms" },
              { label: "Amenities", href: "#amenities" },
              { label: "Gallery", href: "#gallery" },
              { label: "Location", href: "#location" },
            ].map((l) => (
              <button
                key={l.href}
                data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                onClick={() => scrollToSection(l.href)}
                className="w-fit text-left text-sm font-light text-stone-300 transition-colors hover:text-gold"
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>
        <div>
          <h4 className="text-[10px] font-medium uppercase tracking-[0.28em] text-gold">Contact</h4>
          <div className="mt-5 flex flex-col gap-4 text-sm font-light text-stone-300">
            <p className="flex items-start gap-2.5">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold/70" />
              {HOTEL.address}
            </p>
            <p className="flex items-center gap-2.5">
              <Phone className="h-4 w-4 shrink-0 text-gold/70" />
              <a href={HOTEL.phoneHref} data-testid="footer-phone" className="transition-colors hover:text-gold">{HOTEL.phone}</a>
            </p>
          </div>
        </div>
      </div>
      <div className="border-t border-gold/10">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-3 px-5 py-6 sm:px-8">
          <p className="text-xs font-light text-stone-500">
            © {new Date().getFullYear()} Hotel Raj, Dhaka · East Champaran, Bihar
          </p>
          <Link
            to="/admin"
            data-testid="admin-portal-link"
            className="text-xs uppercase tracking-[0.2em] text-stone-500 transition-colors hover:text-gold"
          >
            Admin Portal
          </Link>
        </div>
      </div>
    </footer>
  );
}
